import { MarketplaceItem } from '@appTypes/MarketplaceTypes'
import styled from 'styled-components'
import { useMarketplaceRoute } from '../../../hooks/RouteHooks'
import CardBase from '../../design-system/CardBase'

export interface ListedCardProps {
  erc20: MarketplaceItem
}

export default function ListedCard({ erc20 }: ListedCardProps) {
  const route = useMarketplaceRoute(erc20)

  return (
    <CardBase
      totalMembers={erc20.usersCount}
      totalNfts={erc20.nftCount || 1}
      network={erc20.chainId}
      animationUrl={erc20.metadata?.animation_url}
      imageUrl={String(erc20.metadata?.image)}
      urlRedirect={route}
    >
      <Footer>
        <Info>
          <h4>{`${erc20.name || erc20?.metadata?.name}`}</h4>
        </Info>
      </Footer>
    </CardBase>
  )
}

const { Footer, Info } = {
  Footer: styled.div`
    background: ${props => props.theme.colors.gray[1]};
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  `,
  Info: styled.div`
    padding: 8px 16px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 28px 24px;

    > h4 {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: normal;
      color: ${props => props.theme.colors.black};
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  `
}
